/*
 * Copyright (c) 2026 Oray Inc. All rights reserved.
 *
 * No Part of this file may be reproduced, stored
 * in a retrieval system, or transmitted, in any form, or by any means,
 * electronic, mechanical, photocopying, recording, or otherwise,
 * without the prior consent of Oray Inc.
 *
 * @Author: huangweiliang<huangweiliang@oray.com>
 * @Date: 2026-01-13
 * @LastEditors: huangweiliang<huangweiliang@oray.com>
 * @LastEditTime: 2026-01-09 19:12:36
 * @FileName: global.ts
 * @Description: []
 */

import { Environment } from './types'
import { ClientWebConfig } from './modules/client-web/types'

export interface OrayConfig {
  env?: Environment
  debug?: boolean

  /**
   * ClientWeb 模块配置
   */
  clientWeb?: ClientWebConfig
}

// 全局配置单例
export const globalState: OrayConfig = {
  env: 'production',
  debug: false,
}

// 保存一个监听器列表，当配置更新时通知各模块
const listeners: ((config: OrayConfig) => void)[] = []

/**
 * 注册配置变更监听
 */
export function onConfigChange(callback: (config: OrayConfig) => void) {
  listeners.push(callback)
}

/**
 * 设置全局配置
 */
export function config(options: OrayConfig) {
  Object.assign(globalState, options)

  if (globalState.debug) {
    console.log('[OraySDK] Global config updated:', globalState)
  }

  // 通知监听者
  listeners.forEach((cb) => cb(globalState))
}

/**
 * 获取当前的 API 环境配置
 */
export function getGlobalEnv(): Environment {
  return globalState.env || 'production'
}

export function isDebug(): boolean {
  return !!globalState.debug
}
